<i class="material-icons">email</i>
<div class="space"></div>
<ng-container i18n="@@messageSent">Message sent</ng-container>
